import { useCallback, useState } from "react";

import type { MobileDisplayType } from "../../types";

function useDisplayType(initialDisplayType: MobileDisplayType = "map") {
  const [displayType, setDisplayType] = useState(initialDisplayType);

  const change = useCallback((type: MobileDisplayType) => {
    setDisplayType(type);
  }, []);

  const toggle = useCallback(() => {
    setDisplayType((current) => {
      return current === "map" ? "list" : "map";
    });
  }, []);

  const isMap = displayType === "map";
  const isList = displayType === "list";

  return { isMap, isList, toggle, change };
}

export { useDisplayType };
